"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findIn, on} from "@elements/dom-utils";

export function init() {

    onFind('.js-filter-dropdown', function (dropdown) {
        let menu = findIn('.js-filter-dropdown__menu', dropdown);
        on('click', function(evt) {
            evt.stopImmediatePropagation();
        }, menu)

    });
}